import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
	Shield,
	CheckCircle,
	Clock,
	Users,
	ArrowRight,
	BarChart3,
	Mail,
	Calendar,
} from 'lucide-react';
import logo from '../assets/logo.svg';
import Button from './ui/Button';

const HomePage: React.FC = () => {
	const navigate = useNavigate();

	return (
	  <div className="min-h-screen bg-gray-50">
	    {/* Header */}
	    <header className="bg-white shadow-sm border-b border-gray-100 fixed top-0 left-0 right-0 z-50">
	      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4">
	        <div className="flex items-center justify-between">
	          <div className="flex items-center gap-3">
	            <img src={logo} alt="GhanaID Verify Logo" className="w-50 h-20" />
	          </div>
	          <nav className="hidden md:flex items-center gap-6">
	            <Button onClick={() => navigate('/verify')}>Verify Now</Button>
	          </nav>
	        </div>
	      </div>
	    </header>

	    {/* Hero Section */}
	    <section className="mx-auto px-4 sm:px-6 lg:px-8 py-16 min-h-screen flex items-center justify-center">
	      <div className="text-center">
	        <h2 className="text-4xl md:text-6xl font-bold text-midnight-blue mb-6 leading-tight">
	          Secure Identity Verification
	          <span className="block text-brand-orange">Made Simple</span>
	        </h2>
	        <p className="text-hero text-cool-gray mb-8 max-w-3xl mx-auto leading-relaxed">
	          Verify your Ghana Card identity quickly and securely using advanced facial recognition
	          technology. Trusted by thousands of Ghanaians for secure identity verification.
	        </p>
	        <div className="flex flex-col sm:flex-row gap-4 justify-center">
	          <Button
	            onClick={() => navigate('/verify')}
	            className="btn-primary text-lg px-8 py-4 flex items-center justify-center gap-2"
	          >
	            Verify Now
	            <ArrowRight className="w-5 h-5" />
	          </Button>
	        </div>
	      </div>
	    </section>
	  </div>
	);
};

export default HomePage;
